import './Page.less'

import { Icon, Input } from 'antd'
import api from 'api'
import AppAction from 'components/AppAction/AppAction'
import { AppGrid } from 'components/AppGridLayout/AppGrid'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { toTreeData } from 'utils'

const { Search } = Input

interface PageContext {
	currAppModule: any
	setCurrAppModule: (currAppModule: any) => void
	appModuleGroupList: any[]
}
export const PageContext = React.createContext<PageContext>({} as PageContext)

export const Page = () => {
	const [appModuleGroupList, setAppModuleGroupList] = useState([])
	const [currAppModule, setCurrAppModule] = useState({})
	const loadAppModule = async () => {
		let modelingCurrSystem = [] as any[] // getModelingCurrSystem()
		if (!modelingCurrSystem) return
		let AppModuleList = await api.modeling.module.getModuleGroupList({ systemCode: '' })
		let appModuleGroupListData = toTreeData(AppModuleList)
		setAppModuleGroupList(appModuleGroupListData)
		setCurrAppModule(
			appModuleGroupListData && appModuleGroupListData.length > 0 && appModuleGroupListData[0].children[0]
		)
	}
	// useEffect(() => {
	// 	loadAppModule()
	// }, [getAppModuleGroupList()])
	
	return (
		<PageContext.Provider value={{ currAppModule, setCurrAppModule, appModuleGroupList }}>
			<div className="modeling-page">
				<PageHeard />
				<PageBody />
			</div>
		</PageContext.Provider>
	)
}

const PageHeard = () => {
	const context = useContext(PageContext)
	const addComponent = () => {
		if (context.currAppModule) {
			window.open(`/modeling/desiger/GridDesiger?application=${context.currAppModule.showCode}`)
		}
	}
	const addPage = () => {
		if (context.currAppModule) {
			window.open(`/modeling/desiger/pageDesiger?application=${context.currAppModule.showCode}`)
		}
	}
	return (
		<div className="modeling-page-header">
			<div className="modeling-page-header-toolbar">
				<div className="modeling-page-header-toolbar-left">
					<Search placeholder="输入页面名称" onSearch={value => console.log(value)} style={{ width: 200 }} />
				</div>
				<div className="modeling-page-header-toolbar-right">
					<div className="modeling-page-header-toolbar-right-button">
						<AppAction icon="plus-circle" title="新增页面" action={addPage}></AppAction>
					</div>
					<div className="modeling-page-header-toolbar-right-button">
						<AppAction icon="plus-circle" title="新增组件" action={addComponent}></AppAction>
					</div>
				</div>
			</div>
		</div>
	)
}

const PageBody = () => {
	return (
		<div className="modeling-page-body">
			<div className="modeling-page-body-inner">
				<div className="modeling-page-body-inner-left">
					<FunctionTree />
				</div>
				<div className="modeling-page-body-inner-right">
					<PageGrid></PageGrid>
				</div>
			</div>
		</div>
	)
}

const PageGrid = () => {
	const context = useContext(PageContext)
	let gridData = {
		defaultViewId: 1,
		appGridViewList: [
			{
				viewId: 1,
				title: '页面',
				appTable: {
					colActionWidth: 110,
					apiPath: '/api/modeling/appPage/getList?application=' + context.currAppModule.showCode,
					type: 'apiPath',
					showIndexColumn: false,
					paging: false,
					tableActionList: [
						{
							title: '编辑',
							onClick: (data: any) => editPage(data),
						},
						{
							title: '预览',
							onClick: (data: any) => previewPage(data),
						},
					],
					appTableColList: [
						{ title: '页面名称', width: 200, field: 'name' },
						{ title: '修改人', width: 200, field: 'modifiedBy' },
						{
							title: '修改时间',
							width: 150,
							field: 'modifiedOn',
							align: 'center',
							format: 'YYYY-MM-DD HH:mm:ss',
							fixed: '',
						},
					],
				},
			},
			{
				viewId: 2,
				title: '组件',
				appTable: {
					colActionWidth: 110,
					apiPath: '/api/modeling/appPage/getComponentList?application=' + context.currAppModule.showCode,
					type: 'apiPath',
					showIndexColumn: false,
					paging: false,
					tableActionList: [
						{
							title: '编辑',
							onClick: (data: any) => edit(data),
						},
						{
							title: '预览',
							onClick: (data: any) => preview(data),
						},
					],
					appTableColList: [
						{ title: '组件名称', width: 200, field: 'name' },
						{ title: '类型', width: 200, field: 'type' },
						{ title: '修改人', width: 200, field: 'modifiedBy' },
						{
							title: '修改时间',
							width: 150,
							field: 'modifiedOn',
							align: 'center',
							format: 'YYYY-MM-DD HH:mm:ss',
							fixed: '',
						},
					],
				},
			},
		],
	}
	const edit = (data: any) => {
		if (data && data.id) window.open(`/modeling/desiger/GridDesiger?application=${data.application}&id=${data.id}`)
	}
	const preview = (data: any) => {
		// if (data && data.id) window.open(`/appGrid/${data.id}?application=${data.application}`)
		if (data && data.id) window.open(`/std/${data.application}/appGrid/${data.id}`)
	}
	const editPage = (data: any) => {
		if (data && data.id) window.open(`/modeling/desiger/PageDesiger?application=${data.application}&id=${data.id}`)
	}
	const previewPage = (data: any) => {
		// if (data && data.id) window.open(`/appGrid/${data.id}?application=${data.application}`)
		if (data && data.id) window.open(`/std/${data.application}/appPage/${data.id}`)
	}
	return <AppGrid {...gridData} application={context.currAppModule.showCode} />
}

const FunctionTree = () => {
	const [exportStateList, setExportStateList] = useState([])
	const context = useContext(PageContext)
	const chgExportState = (appModuleGroup: ModuleGroupVo) => {
		let exportState = exportStateList.find(t => t.id === appModuleGroup.fullCode)
		if (exportState) {
			exportState.export = !exportState.export
		} else {
			exportStateList.push({ id: appModuleGroup.fullCode, export: true })
		}
		setExportStateList([...exportStateList])
	}
	const getExportState = (appModuleGroup: ModuleGroupVo) => {
		let exportState = exportStateList.find(t => t.fullCode === appModuleGroup.fullCode)
		if (exportState) {
			return exportState.export
		}
		return false
	}
	const chgCurrAppModule = (e: any, appModule: ModuleVo) => {
		e.nativeEvent.stopImmediatePropagation()
		e.stopPropagation()
		context.setCurrAppModule(appModule)
	}
	return (
		<ul className="function-tree">
			{context.appModuleGroupList.map((appModuleGroup: any) => {
				return (
					<li
						key={appModuleGroup.showCode}
						className="function-tree-item"
						onClick={e => chgExportState(appModuleGroup)}
					>
						<Icon
							type={getExportState(appModuleGroup) ? 'caret-down' : 'caret-right'}
							className="function-tree-item-icon"
						/>
						<span title={appModuleGroup.name} className="function-tree-item-label">
							{appModuleGroup.name}
						</span>
						{getExportState(appModuleGroup) ? (
							<ul className="function-tree-menu">
								{appModuleGroup.children.map((appModule: any) => {
									return (
										<li
											key={appModule.showCode}
											onClick={e => chgCurrAppModule(e, appModule)}
											className={`function-tree-item ${
												context.currAppModule.id === appModule.id
													? 'function-tree-item-select'
													: ''
											}`}
										>
											<span title={appModule.name} className="function-tree-item-label">
												{appModule.name}
											</span>
										</li>
									)
								})}
							</ul>
						) : (
							''
						)}
					</li>
				)
			})}
		</ul>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/Page.tsx